const MAX_LENGTH_FIELD = 256
const MAX_LENGTH_DESCRIPTION = 10000

export { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION }
